import {Grid, makeStyles} from '@material-ui/core';
import React from 'react';
import {useTranslation} from 'react-i18next';

const useStyles = makeStyles(theme => ({
  root: {
    background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    border: 0,
    borderRadius: 3,
    boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    color: 'white',
    height: 48,
    padding: '0 30px',
  },
  fixedLabel: {
    [theme.breakpoints.down('sm')]: {
      position: 'fixed',
      bottom: 5,
      zIndex: 50,
      right: 15,

      '& p': {
        boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.3)',
      },
    },
  },
  simpleLabel: {
    [theme.breakpoints.down('sm')]: {
      position: 'relative',

      '& p': {
        boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.3)',
      },
    },
  },
}));

interface IProps {
  min: number;
  max: number;
  count: number;
  fixed?: boolean;
}
const LabelCountElection: React.FC<IProps> = ({min, max, count, fixed}) => {
  const {t} = useTranslation();
  const classes = useStyles();

  const getLabelClass = () => {
    if (count < min || count > max) {
      return 'default-subtitle text-center label-count-election error-tag';
    } else {
      return 'default-subtitle text-center label-count-election success-tag';
    }
  };

  const getLabelCountOptions = () => {
    if (min <= 1 && max <= 1) {
      return t('etiqueta-contador-escolhas.faca-sua-escolha');
    } else if (min === max && min !== 1) {
      return t('etiqueta-contador-escolhas.faca-minimo-escolhas', {
        minimoEscolhas: min,
      });
    } else {
      return t('etiqueta-contador-escolhas.faca-de-minimo-a-maximo-escolhas', {
        minimoEscolhas: min,
        maximoEscolhas: max,
      });
    }
  };

  const getChoichesLabes = () => {
    if (max === 1) {
      return t('etiqueta-contador-escolhas.voce-realizou-x-escolhas_one', {
        numeroEscolhas: count,
        maximoEscolhas: max,
      });
    } else {
      return t('etiqueta-contador-escolhas.voce-realizou-x-escolhas', {
        numeroEscolhas: count,
        maximoEscolhas: max,
      });
    }
  };

  return (
    <Grid container={true} alignItems="center" justify="space-between">
      <p className="default-subtitle text-center">{getLabelCountOptions()}</p>
      <div className={fixed ? classes.fixedLabel : classes.simpleLabel}>
        <p className={getLabelClass()}>
          <b>{getChoichesLabes()}</b>
        </p>
      </div>
    </Grid>
  );
};

export default LabelCountElection;



// WEBPACK FOOTER //
// ./src/features/election/components/LabelCountElection.tsx